import CircularProgress from "@mui/material/CircularProgress";
import { type PropsWithChildren } from "react";
import { useTranslation } from "react-i18next";

import { RequestStatus } from "../../../logic/api";

const ProgressView = (props: PropsWithChildren<{
  status: RequestStatus;
  center?: boolean;
  showError?: boolean;
  noDelay?: boolean;
}>) => {

  const { t } = useTranslation();

  if (props.status === RequestStatus.loading) {
    return (
      <div style={{ textAlign: "center", padding: 20 }}>
        <CircularProgress />
      </div>
    );
  }

  if (props.status === RequestStatus.error && props.showError != false) {
    return (
      <div style={{ textAlign: "center" }}>
        <div>
          <b>{t("errors.loadFailed.title")}</b>
        </div>
        <div>{t("errors.loadFailed.message")}</div>
      </div>
    );
  }

  return <>{props.children}</>;
};

export { ProgressView };
